'use strict'
var CustomScroll = require('./dist/reactCustomScroll')

module.exports = CustomScroll
